import React from "react";
import PropTypes from "prop-types";
import ReactMarkdown from "react-markdown";

const MarkdownText = ({ children, className = "" }) => (
    <ReactMarkdown className={className}>{children}</ReactMarkdown>
);

MarkdownText.propTypes = {
    className: PropTypes.string,
    children: PropTypes.oneOfType([
        PropTypes.arrayOf(PropTypes.node),
        PropTypes.node,
    ]).isRequired,
};

export default MarkdownText;
